import { TECHNIQUES_ACTIONS } from "constants/Actions/Techniques";

// Estado inicial del reducer
const aInitialState = {
    aTechniques: [],
    aComboTechniques: [],
    nTotalPages: null,
    oTechnique: null,

    aStages: [],
    aAllStages: [],
    aAllStagesList: [],
    oStage: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a las técnicas almacenadas en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const TechniqueReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case TECHNIQUES_ACTIONS.GET:
            return { ...aState, aTechniques: oAction.data.data, nTotalPages: oAction.data.pages };
        case TECHNIQUES_ACTIONS.GET_COMBO:
            return { ...aState, aComboTechniques: oAction.data.data };
        case TECHNIQUES_ACTIONS.FIND:
            return { ...aState, oTechnique: oAction.data };
        case TECHNIQUES_ACTIONS.FIND_STAGE:
            return { ...aState, oStage: oAction.data };
        case TECHNIQUES_ACTIONS.GET_STAGES:
            return { ...aState, aStages: oAction.data };
        case TECHNIQUES_ACTIONS.GET_ALL_STAGES:
            return { ...aState, aAllStages: oAction.data };
        case TECHNIQUES_ACTIONS.GET_ALL_STAGES_LIST:
            return { ...aState, aAllStagesList: oAction.data };
        case TECHNIQUES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case TECHNIQUES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case TECHNIQUES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, aComboTechniques: [], aTechniques: [] };
        default:
            return aState;
    }
}
